




























import Vue, { PropType } from 'vue';
import { Image } from '@/modules/image';

// export type DataType = {
//   isError: boolean;
// };

export default Vue.extend({
  name: 'GImageFormInput',
  props: {
    owner: { type: String as PropType<string>, required: true },
    valid: { type: Boolean as PropType<boolean>, default: true },
    isTag: { type: Boolean as PropType<boolean>, default: false },
    isPublic: { type: Boolean as PropType<boolean>, default: false },
    exclamation: { type: Array as PropType<string[]>, default: () => [] },
    label: { type: String as PropType<string> },
    isRequired: { type: Boolean as PropType<boolean>, default: false },
    name: { type: String as PropType<string>, required: true },
    multiple: { type: Boolean as PropType<boolean>, default: false },
    disabled: { type: Boolean as PropType<boolean>, default: false },
    error: { type: Array as PropType<string[]>, default: () => [] },
    validate: { type: Function as PropType<Function>, default: () => false },
    reset: { type: Function as PropType<Function>, default: () => false },
    caution: { type: String as PropType<string>, default: null },
    withDescription: { type: Boolean as PropType<boolean>, default: false },
    value: { type: [Object, Array] as PropType<Image | Image[]>, default: null },
  },
  computed: {
    innerValue: {
      get(): Image | Image[] | null {
        return this.value;
      },
      set(val: Image | Image[] | null): void {
        this.$emit('input', val);
      },
    },
  },
  // methods: {
  //   uploadedFunc(data: string) {
  //     if (!data) {
  //       this.isError = true;
  //     } else {
  //       this.isError = false;
  //     }
  //     this.$emit('uploaded', data);
  //   },
  //   multiUploadedFunc(data: string[]) {
  //     if (data.length < 0) {
  //       this.isError = true;
  //     } else {
  //       this.isError = false;
  //     }
  //     this.$emit('multiUploaded', data);
  //   },
  // },
});
